(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("filesafe-js"));
	else if(typeof define === 'function' && define.amd)
		define("EditorKit", ["filesafe-js"], factory);
	else if(typeof exports === 'object')
		exports["EditorKit"] = factory(require("filesafe-js"));
	else
		root["EditorKit"] = factory(root["filesafe-js"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__695__) {
return 